import * as actionTypes from '../actions/actionTypes';
import {
  updateObject
} from '../../shared/utility';

const initialState = {  
  error: false,
  success:false,
  loading:false,
  loaded:false,
  oneDayTotal:0,
  securityThreats:null,
  securityThreatsLoaded:false,
  securityThreatsrefresh:false,
  securityLogInfo: {
    
  'SAFE_BROWSING': {
    'title': 'Secure Browsing',
    'body': 'Protects you from accidentally browsing to suspicious sites, or those known to be malicious. These sites are commonly used to steal personal data or infect visitors with malware.',
    'actionsTitle': 'Recommended Actions',
    'actions': [
      {
        'body': 'Perform Manufacturer (firmware) Update on end device involved in the block. ',
        'link': {
          'url': 'https://google.com',
          'display': 'Click here to learn more.'
        }
      },
      {
        'body': 'Install end point security solution on end device involved in the block. ',
        'link': {
          'url': ' https://www.spectrum.net/support/internet/security-suite-information-and-support/',
          'display': 'Click here to learn more.'
        }
      }
    ]
  },
  'IP_REPUTATION': {
    'title': 'Secure Traffic',
    'body': 'Prevents devices from communicating with internet locations (non-browsing traffic) that are known to be malicious.',
    'actionsTitle': 'Recommended Actions',
    'actions': [
      {
        'body': 'Perform Manufacturer (firmware) Update on end device involved in the block. ',
        'link': {
          'url': 'https://google.com',
          'display': 'Click here to learn more.'
        }
      },
      {
        'body': 'Install end point security solution on end device involved in the block. ',
        'link': {
          'url': ' https://www.spectrum.net/support/internet/security-suite-information-and-support/',
          'display': 'Click here to learn more.'
        }
      }
    ]
  },
  'MODEL_PROFILE': {
    'title': 'Smart Device Protection',
    'body': 'Monitors to detect when predictable devices such as smart doorbells have been compromised, or are critically vulnerable. This can be usually resolved by installing the device’s latest firmware update.',
    'actionsTitle': 'Recommended Actions',
    'actions': [
      {
        'body': 'Perform Manufacturer (firmware) Update on end device involved in the block. ',
        'link': {
          'url': 'https://google.com',
          'display': 'Click here to learn more.'
        }
      },
      {
        'body': 'Install end point security solution on end device involved in the block. ',
        'link': {
          'url': ' https://www.spectrum.net/support/internet/security-suite-information-and-support/',
          'display': 'Click here to learn more.'
        }
      }
    ]
  },
  'REMOTE_ACCESS': {
    'title': 'Smart Device Protection',
    'body': 'Monitors to detect when predictable devices such as smart doorbells have been compromised, or are critically vulnerable. This can be usually resolved by installing the device’s latest firmware update.',
    'actionsTitle': 'Recommended Actions',
    'actions': [
      {
        'body': 'Perform Manufacturer (firmware) Update on end device involved in the block. ',
        'link': {
          'url': 'https://www.spectrum.net/support/internet/security-suite-information-and-support/',
          'display': 'Click here to learn more.'
        }
      },
      {
        'body': 'Install end point security solution on end device involved in the block. ',
        'link': {
          'url': ' https://www.spectrum.net/support/internet/security-suite-information-and-support/',
          'display': 'Click here to learn more.'
        }
      }
    ]
  },
  'DOS': {
    'title': 'Outbound DoS Protection',
    'body': 'Prevents an already-compromised device in the home from flooding internet locations with traffic. This can usually be resolved by installing the device’s latest updates, or installing Spectrum Security Suite (if applicable)',
    'actionsTitle': 'Recommended Actions',
    'actions': [
      {
        'body': 'Perform Manufacturer (firmware) Update on end device involved in the block. ',
        'link': {
          'url': 'https://google.com',
          'display': 'Click here to learn more.'
        }
      },
      {
        'body': 'Install end point security solution on end device involved in the block. ',
        'link': {
          'url': ' https://www.spectrum.net/support/internet/security-suite-information-and-support/',
          'display': 'Click here to learn more.'
        }
      }
    ]
  }
}

};
const resetSecurityThreatsState = (state, action) => {
  return updateObject(state, initialState)
}
const getSecurityThreatsStart = (state, action) => {
  return updateObject(state, {
    loading:true,
    loaded:false,
    error :false,
    success: false
  });
};

const setAdvancedSecurityThreats = (state, action) => {
  let securityThreats = Object.assign({}, action.securityThreats);
  let oneDayTotal =action.securityThreats.oneDayTotal?action.securityThreats.oneDayTotal:state.oneDayTotal
    return updateObject(state, {
      securityThreats: securityThreats,
      securityThreatsLoaded:true,
      loaded:true,
      loading:false,
      securityThreatsrefresh:false,
      oneDayTotal:oneDayTotal
    });
  
 
};


const setAdvancedSecurityThreatsSuccess = (state, action) => {
  return updateObject(state, {
    error :false,
    success: true
  });
};

const setAdvancedSecurityThreatsFailed = (state, action) => { 
  
  return updateObject(state, {
    error :true,
    success: false
  });
};

const setAdvancedSecurityThreatsRefreshEnable =  (state, action) => { 
  
  return updateObject(state, {
    securityThreatsrefresh :true,
    securityThreatsLoaded :false
  });
};

const setSecurityLogInfo = (state, action) => {
  // console.log('INFO tx', action.securityLogInfo)
  return updateObject(state, {
    securityLogInfo:action.securityLogInfo
  });
};


const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_SECURITY_THREATS_START:
      return getSecurityThreatsStart(state, action);
    case actionTypes.SET_ADVANCED_SECURITY_THREATS:
      return setAdvancedSecurityThreats(state, action); 
    case actionTypes.SET_ADVANCED_SECURITY_THREATS_SUCCESS:
      return setAdvancedSecurityThreatsSuccess(state, action);
    case actionTypes.SET_ADVANCED_SECURITY_THREATS_FAILED:
      return setAdvancedSecurityThreatsFailed(state, action); 
    case actionTypes.SET_ADVANCED_SECURITY_THREATS_REFRESH:
      return setAdvancedSecurityThreatsRefreshEnable(state, action);
    case actionTypes.SET_SECURITY_LOG_INFO:
      return setSecurityLogInfo(state, action); 
    default:
      return state;
  }
};

export default reducer;
